import createClient from "openapi-fetch";

import { API_BASE_URL } from "@/config";
import type { paths } from "@/types/api-schema";

export const apiPublicClient = createClient<paths>({ baseUrl: API_BASE_URL });
